import { useSyncExternalStore } from 'react';
/** CSS medya sorgusu durumu. `matchMedia` yoksa (test/SSR) `fallback` döner. */
export function useMediaQuery(query, fallback = true) {
    return useSyncExternalStore((notify) => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
            return () => undefined;
        const mql = window.matchMedia(query);
        mql.addEventListener('change', notify);
        return () => {
            mql.removeEventListener('change', notify);
        };
    }, () => typeof window === 'undefined' || typeof window.matchMedia !== 'function'
        ? fallback
        : window.matchMedia(query).matches, () => fallback);
}
//# sourceMappingURL=use-media-query.js.map